class Fork {

    constructor(options = []) {
        this.options = options;
    }

    getOne(){
        var rand = Math.floor(Math.random() * 100);

        if(rand <= 50){
            return this.options[0];
        } else {
            return this.options[1];
        }
    }
   

}

export default Fork;
